<template>
  <div class="loan-settings">
    <b-row align-h="between" class="mb-3">
      <b-col cols="8">
        <h3 class="mb-0">Loan Settings</h3>
      </b-col>
      <!-- <b-col cols="4" class="d-flex align-items-center justify-content-end">
        Autosave
        <el-switch v-model="enable_autosave" active-color="#099A78" class="ml-2"></el-switch>
        <b-form-input v-model="autosave_time" type="text" @keydown="preventNonNumericInput" style="width: 150px;"
          class="ml-3 mr-2" :disabled="enable_autosave === false"></b-form-input>
        <span>sec</span>
      </b-col> -->
    </b-row>
    <b-card no-body class="p-3">
      <b-row align-h="center">
        <b-col cols="8">
          <h3>Feature Settings - Other Payment as below.</h3>
        </b-col>
        <b-col cols="4" class="text-right">
          <el-button type="primary" size="mini" class="mb-2 mx-2" @click="addOtherPaymentItem">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 448 512">
              <path fill="currentColor"
                d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V288h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H256z" />
            </svg>
          </el-button>
        </b-col>
      </b-row>
      <div class="card-table-simple">
        <b-table-simple bordered responsive>
          <b-thead>
            <b-tr>
              <b-th width="10px" class="text-center">No.</b-th>
              <b-th>Type</b-th>
              <b-th>Default Value</b-th>
              <b-th>Description</b-th>
              <b-th></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(item, index) in otherPayment" :key="index">
              <b-td class="text-center">{{ index + 1 }}</b-td>
              <b-td>
                <b-form-input v-model="item.text" style="width: 100%; max-width: unset;"
                  @blur="update(item.id, item)"></b-form-input>
              </b-td>
              <b-td>
                <CurrencyInput v-model="item.setting" @blur="update(item.id, item)"
                  :options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
                <!-- <b-form-input v-model="item.setting" type="text" @keydown="preventNonNumericInput"
                  @blur="update(item.id, item)"></b-form-input> -->
              </b-td>
              <b-td>
                <b-form-input v-model="item.description" style="width: 100%; max-width: unset;"
                  @blur="update(item.id, item)"></b-form-input>
              </b-td>
              <b-td width="30px">
                <el-dropdown trigger="click" style="cursor: pointer">
                  <p class="el-dropdown-link mb-0 top-line">
                    <b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
                  </p>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="removeOtherPaymentItem(index)">
                      <span class="text-danger">
                        <!-- Trash-Can Icon -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
                          <path fill="#DF3030"
                            d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
                        </svg>
                        Delete
                      </span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </b-card>

    <b-card no-body class="p-3">
      <b-row align-h="center">
        <b-col cols="8">
          <h3>Feature Settings - Non-Ccris.</h3>
        </b-col>
        <b-col cols="4" class="text-right">
          <el-button type="primary" size="mini" class="mb-2 mx-2" @click="addFacilities">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 448 512">
              <path fill="currentColor"
                d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V288h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H256z" />
            </svg>
          </el-button>
        </b-col>
      </b-row>
      <div class="card-table-simple">
        <b-table-simple bordered responsive>
          <b-thead>
            <b-tr>
              <b-th width="10px" class="text-center">No.</b-th>
              <b-th>Facility</b-th>
              <b-th>Default Value</b-th>
              <b-th>Description</b-th>
              <b-th></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(item, index) in nonCcris" :key="index">
              <b-td class="text-center">{{ index + 1 }}</b-td>
              <b-td>
                <b-form-input v-model="item.text" style="width: 100%; max-width: unset;"
                  @blur="update(item.id, item)"></b-form-input>
              </b-td>
              <b-td>
                <CurrencyInput v-model="item.setting" @blur="update(item.id, item)"
                  :options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
                <!-- <b-form-input v-model="item.setting" type="text" @keydown="preventNonNumericInput"
                  @blur="update(item.id, item)"></b-form-input> -->
              </b-td>
              <b-td>
                <b-form-input v-model="item.description" style="width: 100%; max-width: unset;"
                  @blur="update(item.id, item)"></b-form-input>
              </b-td>
              <b-td width="30px">
                <el-dropdown trigger="click" style="cursor: pointer">
                  <p class="el-dropdown-link mb-0 top-line">
                    <b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
                  </p>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="removeFacilities(index)">
                      <span class="text-danger">
                        <!-- Trash-Can Icon -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
                          <path fill="#DF3030"
                            d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
                        </svg>
                        Delete
                      </span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </b-card>

    <b-card no-body class="p-3">
      <b-row align-h="center">
        <b-col cols="8">
          <h3>Feature Settings - Proposed Repayment Source.</h3>
        </b-col>
        <b-col cols="4" class="text-right">
          <el-button type="primary" size="mini" class="mb-2 mx-2" @click="addRepaymentSourcesItem">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 448 512">
              <path fill="currentColor"
                d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V288h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H256z" />
            </svg>
          </el-button>
        </b-col>
      </b-row>
      <div class="card-table-simple">
        <b-table-simple bordered responsive>
          <b-thead>
            <b-tr>
              <b-th width="10px" class="text-center">No.</b-th>
              <b-th>Options</b-th>
              <b-th>Percentage Formula (%)</b-th>
              <b-th>Description</b-th>
              <b-th></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(item, index) in repaymentSources" :key="index">
              <b-td class="text-center">{{ index + 1 }}</b-td>
              <b-td>
                <b-form-input v-model="item.text" style="width: 100%; max-width: unset;"
                  @blur="update(item.id, item)"></b-form-input>
              </b-td>
              <b-td>
                <CurrencyInput v-model="item.setting" @blur="update(item.id, item)"
                  :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
                <!-- <b-form-input v-model="item.setting" type="text" @keydown="preventNonNumericInput"
                  @blur="update(item.id, item)"></b-form-input> -->
              </b-td>
              <b-td>
                <b-form-input v-model="item.description" style="width: 100%; max-width: unset;"
                  @blur="update(item.id, item)"></b-form-input>
              </b-td>
              <b-td width="30px">
                <el-dropdown trigger="click" style="cursor: pointer">
                  <p class="el-dropdown-link mb-0 top-line">
                    <b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
                  </p>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="removeRepaymentSourcesItem(index)">
                      <span class="text-danger">
                        <!-- Trash-Can Icon -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
                          <path fill="#DF3030"
                            d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
                        </svg>
                        Delete
                      </span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </b-card>
  </div>
</template>
<script>
import { Switch, Button, Dropdown, DropdownItem, DropdownMenu } from 'element-ui'
import { mapState, mapActions } from 'pinia'
import { useCommonStore } from '@/stores/commonStore'
import { preventNonNumericInput } from '@/assets/js/formValidations.js'
import CurrencyInput from '@/components/CurrencyInput';

export default {
  components: {
    CurrencyInput,
    [Switch.name]: Switch,
    [Button.name]: Button,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      enable_autosave: false,
      autosave_time: 60,
      otherPayment: [],
      repaymentSources: [],
      nonCcris: [],
    }
  },
  created() {
    this.getDroplist('lec_other_payment').then((res) => {
      this.otherPayment = res;
    });

    this.getDroplist('lec_proposed_repayment').then((res) => {
      this.repaymentSources = res;
    });
    this.getDroplist('lec_non_ccris').then((res) => {
      this.nonCcris = res;
    });
  },
  methods: {
    ...mapActions(useCommonStore, ['getDroplist','createDroplist','updateDroplist','deleteDroplist']),
    preventNonNumericInput,
    addOtherPaymentItem() {
      const newPayment = {
        text: 'New Options',
        value: 'New Options',
        type: 'lec_other_payment',
        setting: 0,
        description: ''
      };
      this.otherPayment.push(newPayment);
      this.create(this.otherPayment.length - 1, newPayment);
    },
    removeOtherPaymentItem(index) {
      const id = this.otherPayment[index].id;
      if (index >= 0 && index < this.otherPayment.length) {
        this.otherPayment.splice(index, 1);
      }
      this.delete(id);
    },
    addFacilities() {
      const newNonCcris = {
        text: 'New Options',
        value: 'New Options',
        type: 'lec_non_ccris',
        description: 'New Description'
      };
      this.nonCcris.push(newNonCcris);
      this.create(this.nonCcris.length - 1, newNonCcris);
    },
    removeFacilities(index) {
      const id = this.nonCcris[index].id;
      if (index >= 0 && index < this.nonCcris.length) {
        this.nonCcris.splice(index, 1);
      }
      this.delete(id);
    },
    addRepaymentSourcesItem() {
      const newRepayment = {
        text: 'New Options',
        value: 'New Options',
        type: 'lec_proposed_repayment',
        value: 0,
        description: ''
      };
      this.repaymentSources.push(newRepayment);
      this.create(this.repaymentSources.length - 1, newRepayment);
    },
    removeRepaymentSourcesItem(index) {
      const id = this.repaymentSources[index].id;
      if (index >= 0 && index < this.repaymentSources.length) {
        this.repaymentSources.splice(index, 1);
      }
      this.delete(id);
    },
    create(index, droplist) {
      this.createDroplist(droplist).then(resp => {
        this.droplist[index].id = resp.id;
      });
    },
    update(id, droplist) {
      droplist.value = droplist.text;
      this.updateDroplist(id, droplist);
    },
    delete(id) {
      this.deleteDroplist(id);
    }
  }
}
</script>